<div class="dialog-container">
    <div class="dialog-header">
        <!-- ✅ Shows unique names only once -->
        <h2>{{ issueNameDisplay }} - जाहिरात व्यवसाय आढावा</h2>
    </div>

    <div class="dialog-content">

        <!-- Loading -->
        <div *ngIf="isLoading" class="loader-container">
            <div class="loader"></div>
            <p>लोड होत आहे...</p>
        </div>

        <!-- No data -->
        <div *ngIf="!isLoading && report.length === 0" class="no-data-msg">
            कोणताही डेटा उपलब्ध नाही.
        </div>

        <!-- Report -->
        <div *ngIf="!isLoading && report.length > 0" class="report-wrapper" id="business-report-table">

            <ng-container *ngFor="let offRep of report">
                <table class="ledger-table">
                    <thead>

                        <!-- Main title -->
                        <tr>
                            <th [attr.colspan]="4 + years.length" class="main-title-bg" style="text-align: center;">
                                मागील ४ वर्षांचा {{ issueNameDisplay }} - जाहिरात व्यवसाय आढावा
                            </th>
                        </tr>

                        <!-- Off-rep name + issue name per column -->
                        <tr>
                            <th colspan="4" class="off-rep-name-header">{{ offRep.off_rep_name }}</th>
                            <!-- ✅ Each column shows its own year/issue label from API -->
                            <th *ngFor="let y of years" class="diwali-ank-header">{{ y }}</th>
                        </tr>

                        <!-- Column headers -->
                        <tr>
                            <th class="col-label">अनु.क्र.</th>
                            <th class="col-label">जिल्हा</th>
                            <th class="col-label">तालुके</th>
                            <th class="col-label">प्रतिनिधी</th>
                            <th *ngFor="let y of years" class="year-header">{{ y }}</th>
                        </tr>

                        <!-- Off-rep summary row -->
                        <tr class="off-rep-summary-row">
                            <td colspan="2" class="summary-name-cell" style="font-size: 16px;">{{ offRep.off_rep_name }}
                            </td>
                            <td colspan="2" class="summary-label-cell">एकूण व्यवसाय</td>
                            <td *ngFor="let y of years" class="summary-amount-cell">
                                {{ formatCurrency(offRep.year_totals?.[y]) }}
                            </td>
                        </tr>

                    </thead>

                    <tbody>
                        <ng-container *ngFor="let distGroup of offRep.districts">

                            <tr *ngFor="let row of distGroup.rows; let i = index">
                                <!-- Serial number — rowspan for all rows + total row -->
                                <td *ngIf="i === 0" [attr.rowspan]="distGroup.rows.length + 1" class="serial-cell">
                                    {{ distGroup.serial }}
                                </td>

                                <!-- District name — rowspan for data rows only -->
                                <td *ngIf="i === 0" [attr.rowspan]="distGroup.rows.length" class="district-cell">
                                    {{ distGroup.district }}
                                </td>

                                <td class="taluka-cell">
                                    <span class="taluka-serial">{{ row.taluka_serial }}</span> {{ row.taluka }}
                                </td>
                                <td class="rep-name-cell">{{ row.rep_name }}</td>
                                <td *ngFor="let y of years" class="amount-cell">
                                    {{ formatCurrency(row.year_data?.[y]) }}
                                </td>
                            </tr>

                            <tr class="district-total-row">

                                <!-- District column -->
                                <td class="district-total-name">
                                    {{ distGroup.district }}
                                </td>

                                <!-- Taluka column (empty) -->
                                <td></td>

                                <!-- Representative column -->
                                <td class="district-total-label">
                                    एकूण
                                </td>

                                <!-- Year amount columns -->
                                <td *ngFor="let y of years" class="district-total-amount">
                                    {{ formatCurrency(distGroup.year_totals?.[y]) }}
                                </td>

                            </tr>

                        </ng-container>
                    </tbody>
                </table>
            </ng-container>

            <!-- Grand total footer -->
            <table class="ledger-table grand-footer">
                <tfoot>
                    <tr class="grand-total-row">
                        <td [attr.colspan]="4" class="grand-total-label">सर्व विभागांचा एकूण व्यवसाय</td>
                        <td *ngFor="let y of years" class="grand-total-amount" style="font-size: 16px;font-weight: bold;">
                            {{ formatCurrency(getGrandTotal(y)) }}
                        </td>
                    </tr>
                </tfoot>
            </table>

        </div>
    </div>

    <!-- Actions -->
    <div class="dialog-actions">
        <button class="btn-print" (click)="printPageA4Portrait()">Print</button>
        <button class="btn-excel" (click)="exportToExcel()" [disabled]="isLoading || report.length === 0">
            Excel निर्यात करा
        </button>
        <button class="btn-close" (click)="closeDialog()">बंद करा</button>
    </div>
</div>